import { DefaultValues } from 'react-hook-form'
import { InferType, number, object } from 'yup'

import { requiredMessage } from 'directFlow/state/config/content'
import { Page } from 'directFlow/types'

export const claimFreeDiscountDefaultValues = {
  ncd: {
    ukYears: undefined,
    internationalYears: undefined,
  },
} satisfies DefaultValues<ClaimFreeDiscountSchemaType>

export const claimFreeDiscountSchema = object({
  ncd: object({
    ukYears: number().required(requiredMessage),
    internationalYears: number().when(
      [`$${Page.LICENCE}.countryOfFirstTest`, `$${Page.HISTORY}.hasInternationalNcd`],
      {
        is: (countryOfFirstTest: string, hasInternationalNcd: boolean) => {
          if (countryOfFirstTest !== 'GB' && hasInternationalNcd) {
            return true
          } else {
            return false
          }
        },
        then: () => number().required(requiredMessage).nullable(),
        otherwise: () => number().optional(),
      },
    ),
  }),
})

export type ClaimFreeDiscountSchemaType = InferType<typeof claimFreeDiscountSchema>
